const Tagline = () => {
  return null;
};

export default Tagline;
